import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
// import RealTimeContainer from './RealTimeContainer';
// import DashboardChartMapContainer from './DashboardChartMapContainer';
import StatsComponent from './StatsComponent';
import StatsComponentV2 from './StatsComponentV2'; // for SMARTLGU
import ServicesCount from './ServicesCount';
import ServicesCountV2 from './ServicesCountV2' // for SMARTLGU
// import CollectionsGraph from './CollectionsGraph';
import CollectionsGraph2 from './CollectionsGraph2';
import CollectionsGraphV2 from './CollectionsGraphV2';
import StatisticsContainer from './StatisticsContainer';
import MapComponent from '../components/MapComponent';
// import PropTypes from 'prop-types';

import CmsContext from '../../../context/CmsContext';

function MainDashboardContainer() {
  const cmsContext = useContext(CmsContext)
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  return (
    <div className="container-fluid p-4 mb-3">
      <div className="row">
        <div className="col-md-12 px-1 mb-3">
          {_.get(CMS_COMPONENTS, "SMART_CITY_DASHBOARD") ? <StatsComponentV2 /> : <StatsComponent />}
        </div>
      </div>
      {/* pie chart */}
      <div className="row mt-1">
        <div className="col-md-12">
          {_.get(CMS_COMPONENTS, "SMART_CITY_DASHBOARD") ? <ServicesCountV2 /> : <ServicesCount /> }
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-md-12">
          {_.get(CMS_COMPONENTS, "SMART_CITY_DASHBOARD") ? <CollectionsGraphV2 /> : <CollectionsGraph2 />}
        </div>
      </div>

      <div className="row mt-1 statistics">
        <div className="col-md-8 stat-inner pr-3">
          <StatisticsContainer />
        </div>
        <div className="col-md-4 stat-inner">
          <MapComponent />
        </div>
      </div>
    </div>
  );
}

MainDashboardContainer.propTypes = {};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(MainDashboardContainer);
